import axios from "axios";
import { store } from "@/store/store.js";
import authAxiosService from "@/api/authAxios.service";

// Base axios config object
const axiosConfig = axios.create({
  withCredentials: true, // Needs to be enabled for AFD session affinity cookies to be attached to api requests
  headers: {
    Accept: "application/json",
    // credentials: "same-origin",
    "Content-Type": "application/json",
  },
});

// Use request interceptor to attach access token from Vuex store
axiosConfig.interceptors.request.use(
  async (config) => {
    // If token is missing or blank, try to refresh first
    if (!store.state.login.accessToken || store.state.login.accessToken === '') {
      try {
        const data = await authAxiosService.useRefreshToken();
        if (data && data.token) {
          config.headers["Authorization"] = `Bearer ${data.token}`;
        }
      } catch (err) {
        // If refresh fails, continue without token (will get 401)
      }
    } else if (store.getters['login/isAuthenticated'] === true) {
      config.headers["Authorization"] = `Bearer ${store.state.login.accessToken}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// Use response interceptor for API calls to fetch new access token if existing is invalid
axiosConfig.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    var errorMessage = "";
    if (error.message == "Network Error") {
      errorMessage = "API server not responding";
      alert(errorMessage);
    }
    if (error.response.status == 400) {
      // If we get a .NET validation error, show it in an alert
      // These messages sometimes end up too large to show up in the error toast
      // and result in the Close button sometimes not showing up
      if(error.response.data.title == 'One or more validation errors occurred.') {
        let errorMessageString = 'One or more validation errors occurred:\n';
        let propertyRegex = /(.+?). Path/;
        Object.keys(error.response.data.errors).forEach((x) => {
          errorMessageString += x + ":\n";
          error.response.data.errors[x].forEach(element => {
            errorMessageString += "- " + element.match(propertyRegex)[1] + "\n"
          });
        });

        alert(errorMessageString);
        return Promise.reject({
          data: {
            // Return a "non successful" response instead of just an undefined result
            IsSuccess: false,
            ErrorMessage: 'One or more validation errors occurred.'
          }
        });
      }
      return Promise.reject(error.response);
    }
    //handle API error -Internal server error 500
    if (error.response.status == 500) {
      
      // if(process.env.NODE_ENV === 'development')
      // {
      //   console.log(error.response.data);
      // }
      //alert(error.response.data.ErrorMessage);
      errorMessage =
        "Internal server error on API: " +
        error.response.config.url +
        " \n\n error details: " +
        error.response.data;
        alert(errorMessage);
      
    }
    const originalRequest = error.config;
    // Check to prevent infinite loop of requests
    if (
      (originalRequest._retry) || originalRequest.url === `${process.env.VUE_APP_API_AUTH_URL}/WebAuthV2/refresh`
    ) {
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Use the shared refresh promise from authAxiosService
      return authAxiosService.useRefreshToken()
        .then((data) => {
          if (data && data.token) {
            // Attach the new token to the retry request
            originalRequest.headers["Authorization"] = `Bearer ${data.token}`;
          }
          return axiosConfig(originalRequest);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }
    return Promise.reject(error);
  }
);

export default axiosConfig;
